module.exports = __webpack_public_path__ + "static/media/id-uuid-icon.0e1c16a1.svg";